import { InjectionToken } from "@angular/core";
import { PayrollResponsiblesPort } from "./payroll-responsibles.port";

export const PAYROLL_RESPONSIBLES_PORT =
  new InjectionToken<PayrollResponsiblesPort>("PAYROLL_RESPONSIBLES_PORT");
